import { useState } from "react";
import style from "./style.module.scss";
import SelectFile from "./SelectFile";

const MessageField = ({ textInput, disabled, onFilesChange, attachedFiles, onTextChange, onSendMessage }) => {
    const [isSending, setIsSending] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSending || disabled) return;
        setIsSending(true);
        try {
            await onSendMessage(e);
        } finally {
            setIsSending(false);
        }
    };

    return (
        <form className={style.form} onSubmit={handleSubmit}>
            <div className={style.form_wrapper}>
                <input
                    value={textInput}
                    className={style.input}
                    onChange={(e) => onTextChange(e.target.value)}
                    type="text"
                    placeholder="Написать сообщение"
                />
                <button
                    title="отправить сообщение"
                    type="submit"
                    disabled={disabled || isSending}
                    className={(disabled || isSending) ? `${style.disabled}` : ""}
                ></button>
            </div>
            <SelectFile onFilesChange={onFilesChange} attachedFiles={attachedFiles} />
        </form>
    );
};

export default MessageField;
